export const PasskeyAppleIcon = ({ className = 'w-6 h-6' }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M16.365 1.43c0 1.14-.42 2.2-1.12 3.01-.76.86-2.01 1.53-3.1 1.44-.14-1.1.4-2.26 1.08-3.02.74-.84 2.05-1.46 3.14-1.43zM20.5 17.27c-.55 1.27-.82 1.84-1.53 2.97-.99 1.57-2.39 3.52-4.12 3.54-1.54.02-1.94-1-4.03-.99-2.09.01-2.53 1.01-4.07.99-1.73-.02-3.05-1.78-4.04-3.35C.7 17.2.1 12.7 1.86 10.1c1.24-1.84 3.2-2.92 5.04-2.92 1.87 0 3.05 1.02 4.6 1.02 1.5 0 2.41-1.02 4.57-1.02 1.64 0 3.38.89 4.62 2.43-4.06 2.22-3.4 8.01.81 9.66z"
        fill="#1F1F1F"
      />
    </svg>
  );
};

export const PasskeyInfoIcon = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="10" cy="10" r="7.25" stroke="#2B7DE1" strokeWidth="1.75" />
      <circle cx="10" cy="6.6" r="1" fill="#2B7DE1" />
      <path
        d="M10 9.1v5"
        stroke="#2B7DE1"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PasskeyTrashIcon = ({ className = 'w-4 h-4' }) => {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M6.1 1.2h3.8l.45 1.3h3.35v1.5H2.3V2.5h3.35L6.1 1.2z" fill="#DA291C" />
      <path d="M3.15 5.4h9.7l-.65 8.15c-.06.7-.64 1.25-1.35 1.25H5.15c-.71 0-1.29-.55-1.35-1.25L3.15 5.4z" fill="#DA291C" />
    </svg>
  );
};
